import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.jsx';
import { inscrire } from './pwa/sw.js';
import { appliquerTheme } from './theme.js';

// Le thème est posé AVANT le premier rendu : sinon le fond par défaut clignote en
// sombre puis bascule, et sur une application installée ce clignotement est la
// première chose qu'on voit à chaque ouverture.
try { appliquerTheme(localStorage.getItem('aja.theme') ?? 'sombre'); } catch { appliquerTheme('sombre'); }

createRoot(document.getElementById('racine')).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// L'inscription vient APRÈS le rendu : elle n'a rien à faire dans le chemin critique
// du premier affichage, et une erreur d'inscription ne doit pas empêcher l'écran.
inscrire();
